<template>
    <v-flex xs12 sm12 d-block class="card-dados documento">
        <h3 class="card-dados__titulo">Documentos</h3>

        <az-call-to-action flat css-class="d-flex align-center btn-adicionar" v-if="exibirBotaoAdicionar"
                           @click="exibirCampoDeNovoDocumento">
            <v-icon class="icone" color="white">
                add
            </v-icon>
            Novo Documento
        </az-call-to-action>

        <div v-show="!exibirBotaoAdicionar" class="area-novo">
            <label>Novo Documento:</label>
            <v-combobox v-model="valor.documento" class="area-novo__input" persistent-hint ref="selecaoDocumento"
                        autofocus :items="documentosNaoInseridos" placeholder="Informe o nome" maxlength="150"
                        item-text="nome" item-value="id" name="Nome" v-validate="'required'" required
                        :error-messages="errors.collect('Nome')" :search-input.sync="atualizar">
            </v-combobox>
            <v-tooltip top>
                <v-btn id="botaoAdicionar" slot="activator" outline flat small color="primary"
                       @click="adicionarDocumento">
                    <v-icon size="20">check</v-icon>
                </v-btn>
                Adicionar
            </v-tooltip>
            <v-tooltip top>
                <v-btn id="botaoCancelar" slot="activator" outline flat small color="#777"
                       @click="cancelarNovoDocumento">
                    <v-icon size="20">close</v-icon>
                </v-btn>
                Cancelar
            </v-tooltip>
        </div>

        <v-layout wrap align-center white class="area-conteudo" v-if="value.length > 0">
            <v-flex xs12 sm6 md4 d-flex v-for="(documento, index) in value" :key="index" class="pa-1">
                <p>
                    - {{ documento.documentoId | documentoFilter(documentos) }}
                    <botao-excluir @excluir="exibirModalExcluirDocumento(documento.id)" class="ml-2 botao-excluir"/>
                </p>
            </v-flex>
        </v-layout>

        <p v-else class="frase">
            Não há documentos adicionados
        </p>

        <mensagem-confirmacao :exibirMensagem="mostrarDialogoExclusao"
                              @confirmado="tratarEventoExcluirDocumento"
                              @recusado="mostrarDialogoExclusao = false"/>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelDocumentoSolicitadoEdicao',
    props: {
        value: {
            required: true
        },
        documentos: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        }
    },
    inject: ['$validator'],
    data() {
        return {
            exibirBotaoAdicionar: true,
            valor: {},
            documentoSolicitadoId: null,
            mostrarDialogoExclusao: false,
            nomeDocumentoTemporario: null,
            atualizar: null
        }
    },
    computed: {
        documentosNaoInseridos() {
            const docsNaoInseridos = []
            this.documentos.forEach(doc => {
                if (!this.verificarDocumentoInserido(doc.id)) {
                    docsNaoInseridos.push(doc)
                }
            })
            return docsNaoInseridos
        }
    },
    methods: {
        exibirCampoDeNovoDocumento() {
            this.exibirBotaoAdicionar = false
            setTimeout(() => {
                this.focusInput()
            },300)
        },
        cancelarNovoDocumento() {
            this.exibirBotaoAdicionar = true
            this.valor = {
                documento: null
            }
            this.nomeDocumentoTemporario = null
            this.atualizar = null
            this.$validator.reset()
        },
        async adicionarDocumento() {
            await this.validarCampoObrigatorio()
            if (this.valor.documento && this.valor.documento.id && (this.valor.documento.nome === this.nomeDocumentoTemporario)) {
                this.$emit('adicionarNovoDocumento', this.valor.documento.id)
            } else {
                this.$emit('adicionarDocumentoSemVinculo', this.nomeDocumentoTemporario)
            }
            this.cancelarNovoDocumento()
        },
        verificarDocumentoInserido(documentoId) {
            return this.value.some(item => item.documentoId === documentoId)
        },
        async validarCampoObrigatorio() {
            const estaValido = await this.$validator.validate('Nome')
            if (!estaValido && !this.nomeDocumentoTemporario) {
                throw new Error('Campo obrigatório.')
            }
        },
        exibirModalExcluirDocumento(documentoId) {
            this.documentoSolicitadoId = documentoId
            this.mostrarDialogoExclusao = true
        },
        tratarEventoExcluirDocumento() {
            this.$emit('excluirDocumento', this.documentoSolicitadoId)
            this.mostrarDialogoExclusao = false
        },
        focusInput() {
            this.$refs.selecaoDocumento.focus()
        }
    },
    filters: {
        documentoFilter(docId, documentos) {
            const documentosEncontados = documentos.filter(doc => doc.id === docId)
            if (documentosEncontados.length > 0) {
                return documentosEncontados[0].nome
            }
            return ''
        }
    },
    watch: {
        atualizar (val) {
            this.nomeDocumentoTemporario = val
        }
    }
}
</script>

<style scoped lang="stylus">
    .documento div[role="listitem"]
        display none

    .area-conteudo
        padding 16px 16px 0
        color #888

    .btn-adicionar
        border 0
        color #777 !important
        padding 0
        margin 0 0 0 16px

        &:hover:before, &:focus:before, &:active:before
            background-color #fff

        .icone
            background-color var(--v-primary-base)
            padding 6px
            border-radius 20px
            margin-right 8px

    .botao-excluir
        font-size 16px

        a
            color #777 !important

    .frase
        color #888
        font-size 13px
        padding 10px
        margin-bottom 0

    @media (max-width 500px)
        .area-conteudo
            padding 10px 10px 0
</style>